
import React, { useState } from 'react';
import { Mail, FileText, MapPin, BarChart2 } from 'lucide-react';
import { NewsletterForm } from '@/components/home/NewsletterForm';
import { ActionCard } from './ActionCard';
import { useNavigate } from 'react-router-dom';

interface ActionGridProps {
  onShowBarometerPopup: () => void;
}

export const ActionGrid: React.FC<ActionGridProps> = ({
  onShowBarometerPopup,
}) => {
  const [showNewsletterForm, setShowNewsletterForm] = useState(false);
  const navigate = useNavigate();

  const handleNewsletterButtonClick = () => {
    console.log('Newsletter button clicked');
    setShowNewsletterForm(true);
  };

  const handleCharteButtonClick = () => {
    // Check if we're in production (or preview) to use hash-based routing
    const isProduction = window.location.hostname !== 'localhost' && 
                        !window.location.hostname.includes('127.0.0.1');
    
    console.log("Charte button clicked", { 
      isProduction,
      hostname: window.location.hostname,
      currentPath: window.location.pathname
    });
    
    if (isProduction) {
      // In production, use standard routing
      window.location.href = '/charte-republicaine';
    } else {
      // In development, use standard routing
      navigate('/charte-republicaine');
    }
  };

  return (
    <div className="grid md:grid-cols-2 gap-8 mb-12 relative">
      {/* Bloc 1: Newsletter */}
      <ActionCard
        icon={Mail}
        title="Restez informés"
        description="Recevez nos actualités et participez à nos événements exclusifs."
        buttonText="S'inscrire à la newsletter"
        buttonAction={handleNewsletterButtonClick}
        backgroundColor="bg-[#FCACF4]"
      />

      {/* Newsletter Form Modal */}
      {showNewsletterForm && (
        <NewsletterForm 
          onSuccess={() => setShowNewsletterForm(false)}
          onClose={() => setShowNewsletterForm(false)}
          isModal={true}
        />
      )}

      {/* Bloc 2: Signatures de la Charte */}
      <ActionCard
        icon={FileText}
        title="Les Signatures de la Charte"
        description="Rejoignez les citoyens qui se sont engagés en signant notre charte républicaine."
        buttonText="Signer la charte"
        buttonAction={handleCharteButtonClick}
        backgroundColor="bg-[#39CCFF]"
      />

      {/* Temporairement masqué - Bloc 3: L'indice de la Citoyenneté Française
      <ActionCard
        icon={BarChart2}
        title="L'indice de la Citoyenneté Française"
        description="Consultez les chiffres clés et analyses sur la citoyenneté et la laïcité en France."
        buttonText="Découvrer ICF 2025"
        buttonAction={() => navigate('/indice-citoyennete')}
        backgroundColor="bg-[#FFFF4D]"
      />
      */}

    </div>
  );
};
